<script lang="ts">
  import { login } from "../stores/auth";
  import { ApiError } from "../api";
  import DarkModeToggle from "./DarkModeToggle.svelte";

  let username = $state("");
  let password = $state("");
  let error = $state<string | null>(null);
  let submitting = $state(false);

  async function handleSubmit(event: SubmitEvent): Promise<void> {
    event.preventDefault();
    if (submitting) return;
    submitting = true;
    error = null;
    try {
      await login(username, password);
    } catch (err) {
      error = err instanceof ApiError ? err.message : "Could not reach the server";
    } finally {
      submitting = false;
    }
  }
</script>

<div class="page">
  <div class="toggle-corner">
    <DarkModeToggle />
  </div>
  <form class="card" onsubmit={handleSubmit}>
    <h1>Groceries</h1>
    <label>
      Username
      <input
        type="text"
        autocomplete="username"
        bind:value={username}
        required
        maxlength="64"
      />
    </label>
    <label>
      Password
      <input
        type="password"
        autocomplete="current-password"
        bind:value={password}
        required
        maxlength="256"
      />
    </label>
    {#if error}
      <p class="error">{error}</p>
    {/if}
    <button type="submit" disabled={submitting}>
      {submitting ? "Signing in…" : "Sign in"}
    </button>
  </form>
</div>

<style>
  .page {
    min-height: 100dvh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    position: relative;
  }
  .toggle-corner {
    position: absolute;
    top: max(0.5rem, env(safe-area-inset-top));
    right: max(0.5rem, env(safe-area-inset-right));
  }
  .card {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 2rem;
    width: 100%;
    max-width: 360px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  h1 {
    margin: 0 0 0.5rem;
    text-align: center;
  }
  label {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    font-size: 0.9rem;
    color: var(--text-muted);
  }
  input {
    padding: 0.75rem;
    border-radius: var(--radius);
    border: 1px solid var(--border);
    background: var(--bg);
    color: var(--text);
    font-size: 1rem;
  }
  button[type="submit"] {
    padding: 0.85rem;
    border: none;
    border-radius: var(--radius);
    background: var(--accent);
    color: var(--accent-contrast);
    font-weight: 600;
    cursor: pointer;
  }
  button[type="submit"]:disabled {
    opacity: 0.6;
  }
  .error {
    color: var(--danger);
    font-size: 0.9rem;
    margin: 0;
  }
</style>
